/**
 * USM (Uzungöl Store Manager) axios instance.
 * Separate from storefront `lib/api.js` so internal tokens never leak into
 * customer requests and vice-versa. Base URL points at /api/usm.
 */
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const USM_BASE = BACKEND_URL + "/api/usm";
export const USM_TOKEN_KEY = "uk-usm-token";

const usmApi = axios.create({
  baseURL: USM_BASE,
  headers: { "Content-Type": "application/json" },
});

usmApi.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem(USM_TOKEN_KEY);
    if (token) config.headers.Authorization = `Bearer ${token}`;
  } catch (e) { /* ignore */ }
  return config;
});

usmApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      try { localStorage.removeItem(USM_TOKEN_KEY); } catch (e) { /* ignore */ }
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/usm/login")) {
        window.location.href = "/usm/login";
      }
    }
    return Promise.reject(err);
  }
);

export default usmApi;
